import { MEASURES_VISIBLE } from '../utils/measurePages';

export function pagerLabel(
  windowStart: number,
  measureCount: number,
  visibleCount = MEASURES_VISIBLE,
): string {
  if (measureCount <= visibleCount) {
    return measureCount === 1 ? 'Compás 1' : `Compases 1–${measureCount}`;
  }
  const start = windowStart + 1;
  const end = Math.min(windowStart + visibleCount, measureCount);
  return `Compases ${start}–${end} de ${measureCount}`;
}
